export const isProduction = process.env.appName === 'production';
